/**
 * etha-cart-ajax-pixel.js — make Glozin's Ajax add reach the Cart Ajax API.
 *
 * Why: Shopify publishes the `product_added_to_cart` customer event — the one
 * that becomes GA4 `add_to_cart`, Meta `AddToCart` and the Klaviyo metric — from
 * the Cart Ajax API (`/cart/add.js`). Glozin posts to bare `/cart/add`
 * (`assets/theme.min.js`, `assets/cart.js`: fetch(`${routes.cart_add_url}`)),
 * which is the form endpoint. Verified 2026-08-26 on the live storefront: real
 * add, cart count 1, no `add_to_cart` anywhere downstream.
 *
 * ponytail: one fetch interceptor instead of editing two vendor bundles (one of
 * them minified) that the next Glozin update overwrites. Rewrites the exact
 * `/cart/add` path only — `main-product.js` already appends `.js` itself, and a
 * blind suffix would have made that `/cart/add.js.js`.
 * Ceiling: delete this file the day Glozin ships `.js` on its own; nothing else
 * depends on it.
 */
(function () {
  var nativeFetch = window.fetch;
  if (typeof nativeFetch !== 'function') return;

  /* Only the add endpoint, only a POST, and only the bare form path — never a
     path that is already the Ajax API. Matches with or without a leading
     origin, with or without a trailing slash, and keeps any query string. */
  var ADD_PATH = /^(https?:\/\/[^/]+)?\/cart\/add\/?(\?.*)?$/;

  window.fetch = function (input, init) {
    try {
      var url = typeof input === 'string' ? input : input && input.url;
      var method = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
      if (url && method === 'POST' && ADD_PATH.test(url)) {
        var rewritten = url.replace(/\/cart\/add\/?(\?|$)/, '/cart/add.js$1');
        if (typeof input === 'string') {
          input = rewritten;
        } else {
          input = new Request(rewritten, input);
        }
      }
    } catch (error) {
      /* Analytics plumbing must never break adding to cart — fall through to
         the original call untouched. */
    }
    return nativeFetch.apply(this, [input, init]);
  };
})();
